<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<div class="flex">
			<div class="flex-grow">
				<h1 class="flex vertical-align">
					<Flag :countryid="data.country.id" size="42" />
					<div class="small-margin-left">Order {{ data.shop_order.id }}</div>
				</h1>
			</div>
			<div class="flex">
				<a
					target="_blank"
					:href="data.feedback_url">
					<button data-testid="feedback-form" class="small-margin-left white">Feedback form</button>
				</a>

				<button class="small-margin-left white" v-on:click="edit_discount = !edit_discount">Discount</button>
				<button class="small-margin-left white" v-on:click="show_charge = !show_charge">Charge</button>
				<button class="small-margin-left white" v-if="!data.fulfilled" :disabled="saving" v-on:click="fulfill()">Fulfill</button>
				<button class="small-margin-left white" v-on:click="showCancelModal = true;" v-if="data.cancelable">Cancel</button>
<!--        <template v-if="data.shop_order">-->
          <button class="small-margin-left white" :disabled="saving" v-on:click="uncancel" v-if="data.shop_order.cancelled_at">Un-Cancel</button>
<!--        </template>-->
				<button class="small-margin-left white" v-on:click="clone = true;" v-if="data.cancelable">Clone</button>

				<button
					v-if="!queued_transaction && data.fulfilled"
					:disabled="saving"
					class="small-margin-left white"
					v-on:click="readyForCapture()">Ready for capture</button>

				<button
					v-if="queued_transaction"
					class="small-margin-left white"
					v-on:click="show_transaction = queued_transaction.id">Transaction</button>

				<div style="position: relative;">
					<button
						class="small-margin-left white"
						v-on:click="$refs.dropdown.toggle()">...</button>

					<OrderDropdown
            on-right
            ref="dropdown"
            :id="data.shop_order.id" />
				</div>
			</div>
		</div>

		<div v-if="!data.fulfilled" class="error margin-top margin-bottom small-padding" style="background: #ffaaaa">
			Order isn't fulfilled
		</div>

    <template v-if="data.lost_shipment">
      <div v-if="!data.lost_shipment.resolved_at || data.lost_shipment.status !== 'parcel-found'"
           class="margin-top margin-bottom small-padding"
           style="background: #ebb400; font-weight: 500">
        <template v-if="data.lost_shipment.status">Order reported as Lost with a status: {{ data.lost_shipment.status }}</template>
        <template v-else>Shipment is reported as lost, but has no status.</template>
      </div>
    </template>

		<Modal
			v-if="clone"
			v-on:close="clone = false"
			>
			<OrderCloning
				:source="getId()"
				/>
		</Modal>

		<Modal v-if="edit_discount" v-on:close="edit_discount = false">
			<template v-if="discount">
				<button
					class="margin-bottom"
					:disabled="saving"
					v-on:click="calculateDiscount">Calculate</button>
				<DiscountEditor view="order" :id="discount.discount.id" />
			</template>
			<template v-else>
        <input
          type="text"
          v-model="add_discount_id"
          :disabled="saving"
          placeholder="Press ID ENTER to add"
          v-on:keyup.enter="addDiscount"
        />
        <span style="margin-left: 15px; margin-right: 15px;">or</span>
				<button
					:disabled="saving"
					v-on:click="createDiscount">Create</button>
			</template>
		</Modal>

		<Modal v-if="show_transaction" v-on:close="show_transaction = false">
			<QueuedTransaction :id="show_transaction" />
		</Modal>

		<Modal v-if="showCancelModal"  v-on:close="showCancelModal = false;" >
			<CancelOrder  @closeModal="toggleCancelModal" :order="data.shop_order" v-on:success="showCancelModal = false; load()" />
		</Modal>

		<Modal v-if="show_charge" v-on:close="show_charge = false">
			<ChargeOrder :id="data.shop_order.id" v-on:success="show_charge = false" />
		</Modal>

		<Tabs :tabs="tabs" v-model="active_tab" v-on:change="tabChange" class="margin-top large-margin-bottom" />

		<div v-show="active_tab === 'shipping'">
      <template v-if="tabs.shipping.loaded">
        <OrderShippingEditor ref="shipping" :order="data.shop_order.id" :autoload="false" />

        <Group title="Shipping" class="margin-top">
          <OrderShipment :id="data.shop_order.id" />
        </Group>
      </template>
		</div>

		<div v-show="active_tab === 'history'">
      <template v-if="tabs.history.loaded">
			  <OrderHistory :id="data.shop_order.id" />
      </template>
		</div>

		<div v-show="active_tab === 'customer'">
      <template v-if="tabs.customer.loaded">
			  <Customer ref="customer" :autoload="false" v-if="data.shop_order.id" :id="data.shop_order.customer_id" />
      </template>
		</div>

		<div v-show="active_tab === 'email_history'">
      <template v-if="tabs.email_history.loaded">
			  <EmailHistory resource="order" :id="getId()" />
      </template>
		</div>

		<div v-show="active_tab === 'matrix'">
			<OrderProductMatrix ref="matrix" :id="getId()" :autoload="false" />
		</div>

		<div v-show="active_tab === 'advanced'">
			<OrderDiagnostics ref="advanced" :id="getId()" :order="order" :autoload="false" />
		</div>

		<div v-show="active_tab === 'uniconta'">
      <template v-if="tabs.uniconta.loaded">
        <div class="margin-bottom">
          <OrderUniconta :id="data.shop_order.id" />
          <div class="border flex small-margin-bottom">
            <div class="border-right small-padding" style="width: 260px;">
              <button :disabled="saving" v-on:click="createMirrorInUniconta();" class="full-width">Create mirror in Uniconta</button>
            </div>
            <div class="small-padding flex-grow flex align-items">
              <div>
                Creates a new sales order in Uniconta based on Woocommerce.
                <br />
                You will be prompted to enter a reference number, which will be used to set "Our reference" in Uniconta.
                <br />
                <strong>Important:</strong> Existing sales orders associated with this order will be deleted, also original sales order.
              </div>
            </div>
          </div>
          <div class="border flex small-margin-bottom">
            <div class="border-right small-padding" style="width: 260px;">
              <button :disabled="saving" v-on:click="createInvoiceInUniconta();" class="full-width">Create Invoice</button>
            </div>
            <div class="small-padding flex-grow flex align-items">
              <div>
                Delete all sales orders, create a new one based on Woocommerce, and invoice the new sales order.
              </div>
            </div>
          </div>
          <div class="border flex small-margin-bottom">
            <div class="border-right small-padding" style="width: 260px;">
              <button :disabled="saving" v-on:click="markAllReturnedAsReturnInUniconta();" class="full-width">Uniconta: Mark as Return</button>
            </div>
            <div class="small-padding flex-grow flex align-items">
              <div>
                Batch operation for "Mark as returned in Uniconta".
                <br />
                All returned items will have new lines created for them in Uniconta with quantity as -1.
                <br />
                <strong>Important:</strong> This operation will not verify if the return line already exists
              </div>
            </div>
          </div>
          <div class="border flex small-margin-bottom">
            <div class="border-right small-padding" style="width: 260px;">
              <button :disabled="saving" v-on:click="runDlv();" class="full-width">DLV Run</button>
            </div>
            <div class="small-padding flex-grow flex align-items">
              <div>
                Verify DLV and Synchronize With Uniconta
              </div>
            </div>
          </div>
        </div>
      </template>
		</div>

		<div v-show="active_tab === 'invoicing'">
      <div class="border flex small-margin-bottom">
				<div class="border-right small-padding" style="width: 260px;">
					<DownloadInvoice :order-id="getId()"/>
				</div>
				<div class="small-padding flex-grow flex align-items">
					<div>
						Download invoice PDF
					</div>
				</div>
			</div>

			<template v-if="data.tracking_flow">
				<template v-if="data.tracking_flow.id">
					<strong>Extra days for invoicing: </strong>
					<input :disabled="saving" type="number" v-model="data.tracking_flow.invoicing_extra_days" />
					<button class="small-margin-left" v-on:click="updateInvoicingDays()" :disabled="saving">Save</button>
				</template>
				<template v-else>
					Tracking flow does not exist. Extra invoicing days cannot be changed at this time
				</template>
			</template>
			<div class="border flex small-margin-bottom">
				<div class="border-right small-padding" style="width: 260px;">
					<button class="full-width" @click="balanceUniconta(true)">Balance Uniconta</button>
				</div>
				<div class="small-padding flex-grow flex align-items">
					<div>
						Balance order in uniconta based on returned order content and woocommerce items then invoice the order.
					</div>
				</div>
			</div>
			<div class="border flex small-margin-bottom">
				<div class="border-right small-padding" style="width: 260px;">
					<button class="full-width" @click="balanceUniconta(false)">Balance Uniconta without invoicing</button>
				</div>
				<div class="small-padding flex-grow flex align-items">
					<div>
						Balance order in uniconta based on returned order content and woocommerce. Only create sales  but do not invoice it.
					</div>
				</div>
			</div>
		</div>

		<div v-show="active_tab === 'payment'">
      <template v-if="tabs.payment.loaded">
        <div class="margin-bottom">
          <Group title="Debt collection" class="margin-bottom">
            <DebtCollection :id="getId()" />
          </Group>

          <Group title="Delete" class="margin-bottom">
            <button :disabled="saving" v-on:click="deletePaymentRecord()">Delete payment record</button>
          </Group>

          <Group title="Payment">
            <OrderPaymentEditor :id="getId()" />
          </Group>

          <Group title="Failed payment" v-if="payment_communication">
            <div class="input-row">
              <div class="label">Stop communication until</div>
              <input type="date" v-model="delay_until" />
            </div>
            <div class="margin-top note">
              Setting above date will <em>only</em> stop communication of email and text messages.
              We will continue to attempt to charge on a daily basis.
            </div>
            <div class="margin-top">
              <button :disabled="saving" v-on:click="updatePaymentCommunication">Save</button>
            </div>
          </Group>

          <Group class="margin-top margin-bottom" title="Queued transaction">
            <template v-if="queued_transaction">
              <div class="input-row">
                <span class="label">Created at</span>
                <Format type="date" :value="queued_transaction.created_at" />
              </div>
              <div class="input-row">
                <span class="label">Last checked/handled at</span>
                <Format type="date" :value="queued_transaction.process_attempted_at" />
              </div>
              <div class="input-row">
                <span class="label">Completed at</span>
                <Format type="date" :value="queued_transaction.processed_at" />
              </div>
              <div class="input-row">
                <span class="label">Fulfillment attempted at</span>
                <Format type="date" :value="queued_transaction.fulfillment_attempted_at" />
              </div>
              <div class="input-row">
                <span class="label">Fulfilled at</span>
                <Format type="date" :value="queued_transaction.fulfilled_at" />
              </div>
            </template>
            <template v-else>
              Queued transaction not created for this order
            </template>
          </Group>
        </div>
      </template>

		</div>

		<div v-show="active_tab === 'attributes'">
			<div v-for="(attribute, key) in attributes" class="flex" :key="key">
				<div class="margin-right">
					<MaterialToggle :label="attribute.label" v-model="attribute.value" />
				</div>
			</div>
			<div class="margin-top">
				<button :disabled="saving" v-on:click="saveAttributes()">Save attributes</button>
			</div>
		</div>

		<div v-show="active_tab === 'transaction_history'">
			<TransactionHistory :id="data.shop_order.id" :countryId="data.country.id" :autoload="false" ref="transaction_history" />
		</div>
		<div v-show="active_tab === 'general'">

			<div class="margin-top modern-grid">

				<!-- Value -->
				<div class="cell">
					<strong>Value</strong>
					{{ data.currency.code }} {{ data.total.native }}
				</div>

				<!-- Pending amount -->
				<div class="cell" v-if="pending_amount">
					<strong>Pending amount</strong>
					<span class="orange">{{ data.currency.code }} {{ pending_amount }}</span>
				</div>

				<!-- Outstanding balance -->
				<div class="balance cell">
					<div class="ready-for-capture">
						<span class="text-uppercase">Ready for capture: {{ data.currency.code }} {{ data.amount_ready_for_capture }}</span>
					</div>
					<strong>Outstanding balance</strong>
					<div class="flex">
						<div v-if="order_balance" class="flex-grow">
							<div class="flex">
								<div class="xs-margin-right">{{ data.currency.code }}</div>
								<div>
									<Format type="number" :value="order_balance.outstanding_balance" />
								</div>
							</div>
							<div class="note flex" style="font-weight: 300;">
								<div class="xs-margin-right">Updated:</div>
								<Format type="date" :time="true" :value="order_balance.last_updated" />
							</div>
						</div>
						<div v-else>
							N/A
						</div>
						<div class="text-right padding-right">
							<button
								:disabled="saving"
								class="small gray"
								v-on:click="updateOrderBalance">Update</button>
						</div>
					</div>
				</div>

				<!-- Order type -->
				<div class="cell">
					<strong>Type</strong>
					{{ getOrderType(data.shop_order.order_type_id) }}
				</div>

				<!-- Order date -->
				<div class="cell">
					<strong>Order date</strong>
					<Format type="date" :value="data.shop_order.created_at" :time="true" />
				</div>
			</div>

			<div class="padding-top padding-bottom">
				<OrderStage v-on:loaded="load_step++" v-if="load_step >= 0" :id="data.shop_order.id" class="margin-top" />
			</div>

			<div class="margin-top"></div>

			<div class="flex margin-top">
				<div class="flex-grow">

					<Group title="Products">

						<div class="flex margin-bottom">
							<div class="flex-grow"></div>
							<div>
								<template v-if="edit_prices">
									<select :disabled="saving" v-model="change_currency">
										<option v-for="currency in getCurrencies" :value="data.currency.id" v-text="currency.iso4217_code"></option>
									</select>
								</template>
							</div>
							<div class="text-right small-margin-left flex">
                <div
                  class="margin-right">
                  <div>Discount</div>
                  <template v-if="data.order_discount">
                    <a :href="'/#/discount/' + data.order_discount.discount.id">{{ data.order_discount.discount.id }}<template
                      v-if="data.order_discount.discount.discount_code"> - {{ data.order_discount.discount.discount_code }}</template></a>
                  </template>
                  <template v-else><em>No discount</em></template>
                </div>
                <div>
                  <button v-on:click="edit_prices = true;" v-if="!edit_prices">Edit prices</button>
                  <button :disabled="saving" v-on:click="edit_prices = false;" v-if="edit_prices" class="gray">Cancel</button>
                  <button :disabled="saving" v-on:click="changeCurrency()" v-if="edit_prices" class="small-margin-left">Change currency</button>
                </div>
							</div>
							<div class="small-margin-left">
								<template v-if="apply_discount">
									<input type="text" v-model="order_discount" placeholder="Percentage">%
								</template>
							</div>
							<div class="text-right small-margin-left">
                <button v-on:click="edit_discount = !edit_discount">Discount</button>
							</div>
						</div>

						<ProductList v-if="load_step === 2" @reloadParent="load()" :order="getId()" />

					</Group>

					<Group v-if="data.shop_order.order_type_id === 1" title="Exchange requests" class="margin-top">
						<ExchangeRequestManager :id="getId()" />
					</Group>

					<Group title="Comments" class="margin-top">
						<!-- {{ comments }} -->
						<div v-for="(comment, index) in data.comments" :key="index" class="small-margin-bottom">
							<div>{{ comment.comment }}</div>
							<div class="flex note">
								<div v-for="user in getUsers" v-if="user.id == comment.user_id" class="very-small-margin-right">
									<strong>By: </strong>
									{{ user.shortened_name }}
								</div>
								<div v-if="comment.created_at">
									on
									<Format style="display: inline-block;" type="date" :time="true" :value="comment.created_at" />
								</div>
							</div>
						</div>

						<div class="margin-top">
							<textarea rows="6" cols="80" v-model="add_comment" />
							<div class="small-margin-top">
								<button :disabled="saving" v-on:click="addComment()">Add comment</button>
							</div>
						</div>
					</Group>

				</div>

			</div>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import OrderPaymentEditor from '@/components/OrderPaymentEditor.vue'
import CancelOrder from '@/components/CancelOrder.vue'
import DebtCollection from '@/components/DebtCollection.vue'
import OrderShipment from '@/components/OrderShipment.vue'
import OrderDropdown from '@/components/OrderDropdown.vue'
import ExchangeRequestManager from '@/components/ExchangeRequestManager.vue'
import DiscountEditor from '@/components/DiscountEditor.vue'
import OrderCloning from '@/components/cloning/OrderCloning.vue'
import DownloadInvoice from '../components/DownloadInvoice.vue'
import _ from 'lodash'

export default {
  components: {
    OrderPaymentEditor,
    CancelOrder,
    OrderDropdown,
    DebtCollection,
    OrderShipment,
    ExchangeRequestManager,
    DiscountEditor,
    OrderCloning,
    DownloadInvoice
  },
  computed: {
    ...mapGetters([
      'getUsers',
      'getCurrencies'
    ]),
    isCancelled () {
      return this.data.shop_order.cancelled_at !== null
    }
  },
  watch: {
    $route: function () {
      this.$router.go(0)
    }
  },
  data: () => ({
    // Used to serialize the order in which many API endpoints are loaded
    load_step: 0,

    add_discount_id: '',

    data: {},

    clone: false,
    order_balance: {},
    add_comment: '',
    show_transaction: false,
    edit_status: false,
    status_list: [],
    loading: true,
    saving: false,
    show_charge: false,
    showCancelModal: false,
    edit_prices: false,
    apply_discount: false,
    pending_amount: false,
    edit_discount: false,
    change_currency: '',
    order_discount: false,
    discount: false,
    order: {},
    lines: [],
    payment_communication: {},
    delay_until: '',
    shipping: [],
    edit_shipping_labels: false,
    queued_transaction: {},
    attributes: {},
    active_tab: 'general',
    tabs: {
      general: {
        name: 'General'
      },
      history: {
        name: 'History'
      },
      matrix: {
        name: 'Product matrix'
      },
      customer: {
        name: 'Customer'
      },
      payment: {
        name: 'Payment'
      },
      shipping: {
        name: 'Shipping'
      },
      transaction_history: {
        name: 'Transaction history'
      },
      invoicing: {
        name: 'Invoicing'
      },
      uniconta: {
        name: 'Uniconta'
      },
      email_history: {
        name: 'Communication'
      },
      attributes: {
        name: 'Attributes'
      },
      advanced: {
        name: 'Advanced'
      }
    },
    wp_url: process.env.VUE_APP_WP_URL
  }),
  methods: {
    deletePaymentRecord () {
      if (confirm('Are you sure? Make sure you understand the consequences')) {
        Vue.$api.delete('/failed-payment/' + this.getId(), {}, {
          loader: toggle => this.saving = toggle,
          callback: data => {
            alert('Record deleted')
          }
        })
      }
    },
    calculateDiscount () {
      Vue.$api.post(
        '/order/' + this.getId() + '/discount/calculate',
        {},
        {
          loader: toggle => this.saving = toggle
        }
      )
    },
    createDiscount () {
      Vue.$api.post(
        '/order/' + this.getId() + '/discount',
        {},
        {
          loader: toggle => this.saving = toggle,
          callback: data => this.load()
        }
      )
    },
    addDiscount () {
      this.saving = true
      Vue.$api.post(
        '/order/' + this.getId() + '/discount/' + this.add_discount_id + '/attach',
        {},
        {
          loader: toggle => this.saving = toggle,
          callback: data => this.load()
        }
      )
    },
    updatePaymentCommunication () {
      this.payment_communication.delay_until = this.delay_until
      Vue.$api.patch(
        '/order/' + this.getId() + '/payment-communication',
        this.payment_communication,
        {
          loader: toggle => this.saving = toggle
        }
      )
    },
    addComment () {
      Vue.$api.post('/order/' + this.getId() + '/comment', {
        comment: this.add_comment
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => {
          this.add_comment = ''
          this.load()
        }
      })
    },
    fulfill () {
      Vue.$api.post('/order/' + this.getId() + '/fulfill', {}, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    },
    tabChange (tab) {
      switch (tab.id) {
        case 'shipping':
        case 'customer':
        case 'history':
        case 'matrix':
        case 'payment':
        case 'advanced':
        case 'transaction_history':
        case 'email_history':
          if (!this.tabs[tab.id].loaded) {
            setTimeout(() => this.$refs[tab.id].load(), 10)

            this.tabs[tab.id].loaded = true
          }
          break
      }
    },
    changeCurrency () {
      Vue.api.patch('/order/' + this.getId() + '/currency', {
        currency: this.change_currency
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.load()
      })
    },
    applyDiscount () {
      Vue.api.post('/order/' + this.getId() + '/apply-discount', {
        percentage: this.order_discount
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.load()
      })
    },
    updateOrderBalance () {
      Vue.$api.post(
        '/order/' + this.getId() + '/balance/refresh',
        {},
        {
          loader: toggle => this.saving = toggle,
          callback: data => this.order_balance = data
        }
      )
    },
    markAllReturnedAsReturnInUniconta () {
      var lines = _.filter(this.lines, function (line) {
        return line.return_reason !== null
      })
      if (_.isEmpty(lines)) {
        alert('There is no items to return.')
        return
      }
      var productIds = []
      _.each(lines, function (line) {
        productIds.push(line.woocommerce_product_id)
      })
      Vue.api.post('/order/' + this.data.shop_order.id + '/products/uniconta/return', { product_id: productIds }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => alert('Done')
      })
    },
    readyForCapture () {
      Vue.api.post('/order/' + this.getId() + '/ready-for-capture', {}, {
        loader: toggle => this.saving = toggle,
        callback: () => {
          location.reload()
        }
      })
    },
    getOrderType (type) {
      switch (type) {
        case 1:
          return 'Styling order'
        case 3:
          return 'Styling fee order'
        case 2:
          return 'Webshop order'
        case 4:
          return 'Exchange order'
        default:
          return type
      }
    },
    getId () {
      return this.$route.params.id
    },
    load () {
      Vue.$ui.setTitle('Order ' + this.getId())

      Vue.api.get('/order/' + this.$route.params.id + '?additional=1', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.parse(data)
      })
    },
    parse (data) {
      this.load_step++

      this.data = data
      this.discount = data.order_discount
      this.lines = data.lines
      this.change_currency = this.data.currency.id
      this.attributes = data.attributes
      this.queued_transaction = data.queued_transaction
      this.payment_communication = data.payment_communication
      this.pending_amount = data.pending_amount
      this.order_balance = data.order_balance
      if (data.payment_communication) {
        this.delay_until = data.payment_communication.delay_until ? data.payment_communication.delay_until.substr(0, 10) : ''
      }
    },
    updateInvoicingDays () {
      Vue.api.put('/order/' + this.$route.params.id + '/invoicing-days', {
        days: this.data.tracking_flow.invoicing_extra_days
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.load()
      })
    },
    saveAttributes () {
      Vue.$api.put('/order/' + this.$route.params.id + '/attributes', {
        data: this.attributes
      }, {
        loader: toggle => this.saving = toggle,
        callback: () => Vue.$ui.message('Attributes saved')
      })
    },
    uncancel() {
      if (!confirm('Are you sure that you want to un-cancel this order?')) {
        return
      }
      Vue.api.post('/order/' + this.$route.params.id + '/uncancel', {
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.load()
      })
    },
    unicontaMirror (reference, callback) {
      Vue.api.post('v2/order/' + this.$route.params.id + '/uniconta/mirror', {
        reference: reference
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => callback()
      })
    },
    createMirrorInUniconta () {
      this.validateMirroring((reference) => {
        this.unicontaMirror(reference, () => {
          alert('Done mirroring')
        })
      })
    },
    balanceUniconta (doInvoice) {
      if (!confirm('Are you sure?')) {
        return
      }
      Vue.api.post('order/' + this.$route.params.id + '/uniconta/balance',
        { 'do-invoice': doInvoice }, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => alert('Done')
        }
      )
    },
    validateMirroring (callback) {
      var reference = prompt('Please choose "Our reference"', this.$route.params.id)
      if (reference) {
        Vue.api.post('order/' + this.$route.params.id + '/uniconta/mirror/validate', {
          reference: reference
        }, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: (response) => {
            if (response.require_verification) {
              if (confirm(response.message)) {
                callback(reference)
              }
            } else {
              callback(reference)
            }
          }
        })
      }
    },
    validateInvoiceInUniconta (callback) {
      Vue.api.post('order/' + this.$route.params.id + '/uniconta/invoice/validate', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: (response) => {
          if (response.require_verification) {
            if (confirm(response.message)) {
              callback()
            }
          } else {
            callback()
          }
        }
      })
    },
    createInvoiceInUniconta () {
      this.validateMirroring((reference) => {
        this.unicontaMirror(reference, () => {
          this.validateInvoiceInUniconta(() => {
            this.createInvoice(() => {
              alert('Done invoicing')
            })
          })
        })
      })
    },
    runDlv () {
      Vue.api.post('order/' + this.$route.params.id + '/dlv/process', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => {
          alert('Done')
        }
      })
    },
    createInvoice (callback) {
      Vue.api.post('order/' + this.$route.params.id + '/uniconta/invoice', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => callback()
      })
    },
    toggleCancelModal () {
      this.showCancelModal = !this.showCancelModal
    }
  },
  created () {
    this.load()
  }
}
</script>

<style lang="less" scoped>
	.action-menu {
		display: flex;
	}
	.btn-legacy {
		background-color: #828282;
	}
	.text-uppercase {
		text-transform: uppercase;
	}
	.balance {
		cursor: pointer;
		position: relative;
		.ready-for-capture {
			position: absolute;
			opacity: 0;
			transform: translate3d(0px, -45px, 0px);
			transition: .80s opacity;
			border: 1px solid #2f3239;
			padding: 10px;
			font-size: 12px;
			font-weight: normal;
			&:after {
				content: '';
				bottom: -8px;
				left: 40px;
				position: absolute;
				width: 0;
				height: 0;
				border: 8px solid transparent;
				border-top-color: black;
				border-bottom-width: 0;
			}
		}
		&:hover {
			.ready-for-capture {
				position: absolute;
				opacity: 1;
				transform: translate3d(0px, -45px, 0px);
				transition: .80s opacity;
			}
		}
	}
</style>
